import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { meQuery, resolveWorkspace, sitesQuery } from '@/lib/queries'

/**
 * Sites are addressed by host now. This survives for links minted before the
 * move — and for anything that only knows a site id, such as a notification.
 */
export const Route = createFileRoute('/_app/sites/$siteId')({
  beforeLoad: async ({ context, params }) => {
    const [me, { sites }] = await Promise.all([
      context.queryClient.ensureQueryData(meQuery),
      context.queryClient.ensureQueryData(sitesQuery),
    ])
    const site = sites.find((candidate) => candidate.id === params.siteId)
    const target = resolveWorkspace(me)
    if (!site || !target) throw notFound()

    throw redirect({
      to: '/$org/$host',
      params: { org: target.slug, host: site.host },
      replace: true,
    })
  },
})
